import React from 'react'

function DashboardMedico(props) {
  return <div>Médico</div>
}

export default DashboardMedico
